import { useLocation, useNavigate } from 'react-router';
import { Product } from 'screens/Checkout';
import { trackSelectItem } from 'utils/tracking';

export function useCheckoutNavigate(product: Product) {
  const navigate = useNavigate();
  const location = useLocation();
  return () => {
    // GA4 select_item : l'utilisateur a choisi une offre dans la liste.
    trackSelectItem(product as unknown as Record<string, unknown>);
    // Naviguer vers l'URL avec l'ID du produit pour préserver l'URL complète
    const checkoutUrl = `/checkout/id/${product.Id}`;
    navigate(checkoutUrl, { state: { product, from: location } });
  };
}
